import { render, staticRenderFns } from "./bannerContent.vue?vue&type=template&id=8b229154"
import script from "./bannerContent.vue?vue&type=script&lang=js"
export * from "./bannerContent.vue?vue&type=script&lang=js"
import style0 from "./bannerContent.vue?vue&type=style&index=0&id=8b229154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports